import { BehaviorSubject, Observable } from 'rxjs';
import { Transput } from '../Models/Platform/Transput';
import { PlatformHelper } from '../Helpers/PlatformHelper';


export class PlatformService {
  public FetchingReadySubject: BehaviorSubject<boolean>;
  public FetchingReady!: boolean;

  private platformId!: string;
  public transputs!: Transput[];

  private FetchingReadyTransputs = false;

  constructor() {
    this.FetchingReadySubject = new BehaviorSubject<boolean>(false);
  }

  private async FetchItems() {
    if (!this.FetchingReady) {
      this.FetchingReady = true;
      this.platformId = await PlatformHelper.GetPlatformIdByType();
      this.transputs = await PlatformHelper.GetTransputs(this.platformId);
      this.FetchingReadySubject.next(true);
    }
  }

  public GetFetchStatus(): Observable<boolean> {
    this.FetchItems();
    return this.FetchingReadySubject;
  }

  // get overview
  public GetTransputs(): Transput[] {
    return this.transputs;
  }
}
